import React from 'react';
import { styled } from '@mui/material';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { range } from 'lodash';
import { classes, StyledList } from './BottomMenuItemsSkeleton.styles';



const BottomMenuItemsSkeleton = () => (
  <StyledList>
    {range(2).map(item => (
      <div key={item}>
        <ListItem>
          <ListItemIcon>
            <Skeleton variant="circle" width={28} height={28} className={classes.skeleton} />
          </ListItemIcon>
          <ListItemText
            primary={<Skeleton variant="text" width={'90%'} height={30} className={classes.skeleton} />}
            secondary={<Skeleton variant="text" width={'50%'} height={15} className={classes.skeleton} />}
          />
        </ListItem>
      </div>
    ))}
  </StyledList>
);

export default BottomMenuItemsSkeleton;
